export function initLocationDropdown(wrapper = document) {
    const locationDropdown = wrapper.querySelector('#input_choose_location');
    const hiddenEmailInput = wrapper.querySelector('input[name="input_recipient_email"]');

    if (locationDropdown) {
        for (let i = 0; i < locationDropdown.options.length; i++) {
            const option = locationDropdown.options[i];

            if (option.value.includes(':')) {
                const [location, email] = option.value.split(':');
                option.textContent = location.trim();
                option.setAttribute('data-email', email.trim());
            }
        }

        // Initiale E-Mail setzen basierend auf aktueller Auswahl
        const initialOption = locationDropdown.options[locationDropdown.selectedIndex];
        if (initialOption) {
            const initialEmail = initialOption.getAttribute('data-email');
            if (initialEmail && hiddenEmailInput) {
                hiddenEmailInput.value = initialEmail;
            }
        }

        locationDropdown.addEventListener('change', function() {
            const selectedOption = locationDropdown.options[locationDropdown.selectedIndex];
            const email = selectedOption.getAttribute('data-email');
            if (email && hiddenEmailInput) {
                hiddenEmailInput.value = email;
            }
        });
    }
}
